<template>
  <v-container class="fill-height">
    <v-row align="center">
      <v-col cols="12" md="6" sm="12">
        <div class="illus">
          <img src="@/assets/images/contact_us.svg" alt="">
        </div>
      </v-col>
      <v-col cols="12" md="6" sm="12" class="pad-lr-100">
        <v-text-field
          label="Nom"
          hint="votre nom"
          v-model="clientMessage.name"
          name="name"
          outlined
          type="text"
          :error-messages="nameErrors"
          @input="$v.clientMessage.name.$touch()"
          @blur="$v.clientMessage.name.$touch()"
        ></v-text-field>
        <v-text-field
          label="E-mail"
          hint="Adresse de contact"
          v-model="clientMessage.email"
          name="email"
          type="email"
          outlined
          :error-messages="emailErrors"
          @input="$v.clientMessage.email.$touch()"
          @blur="$v.clientMessage.email.$touch()"
        ></v-text-field>
        <v-text-field
          label="Numéro de téléphone"
          hint="Votre numéro de téléphone"
          v-model="clientMessage.phone"
          name="phone"
          outlined
          type="number"
          :error-messages="phoneErrors"
          @input="$v.clientMessage.phone.$touch()"
          @blur="$v.clientMessage.phone.$touch()"
        ></v-text-field>
        <v-textarea
          label="Message"
          hint="votre message"
          outlined
          v-model="clientMessage.message"
          :error-messages="messageErrors"
          @input="$v.clientMessage.message.$touch()"
          @blur="$v.clientMessage.message.$touch()"
          auto-grow
        />
        <v-btn color="primary" @click="onSendClick">Envoyer</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    clientMessage: {
      message: { required },
      email: { required, email },
      name: { required },
      phone: { required }
    }
  },
  data() {
    return {
      elapse: null,
      clientMessage: {
        message: "",
        type: "message",
        email: "",
        name: "",
        phone: ""
      }
    };
  },
  computed: {
    ...mapGetters({ loading: "loading" }),
    messageErrors() {
      const errors = [];
      if (!this.$v.clientMessage.message.$dirty) return errors;
      !this.$v.clientMessage.message.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.clientMessage.email.$dirty) return errors;
      !this.$v.clientMessage.email.email &&
        errors.push("enter une adresse email valide");
      !this.$v.clientMessage.email.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.clientMessage.name.$dirty) return errors;
      !this.$v.clientMessage.name.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.clientMessage.phone.$dirty) return errors;
      !this.$v.clientMessage.phone.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    }
  },
  methods: {
    ...mapActions(["sendClientMessage"]),
    onSendClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) this.sendClientMessage(this.clientMessage);
    }
  }
};
</script>

<style scoped>
.container{
  display: grid;
  place-items: center;
  width: 100%;
}
.row{
  width: 100%;
  background: #fff;
  border-radius: 15px;
  padding: 40px;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
}
.illus img{
  max-width: 85%;
  margin: auto;
  display: block;
}
.pad-lr-100{
  padding: 0 100px;
    display: block;
  margin: auto; 
}
.v-text-field--outlined > .v-input__control > .v-input__slot{
  background: #f5f5f5 !important;
}
.v-btn{
  color: #fff;
  background: #E91E24 !important;
  padding: 13px 30px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  height: auto !important;
  margin: auto;
  box-shadow: none !important;
  display: block;
}

@media screen and (max-width: 960px) {
  .pad-lr-100{
    padding: 0;
  }
  .illus img{
    margin-bottom: 30px;
  }
  .v-btn{
    width: 100%
  }
}
</style>